import { Component } from '@angular/core';
import { ItemsFormComponent } from '../components/items-form/items-form.component';
import { ActivatedRoute } from '@angular/router';
import { SavedDataInfo } from '../../../../models/form/saved-data-info';
import { ItemsService } from '../../../../services/api/general-settings/items.service';
import { ItemsAuthorisationComponent } from '../components/items-authorisation/items-authorisation.component';
import { FormNotesCustomersComponent } from '../../../customers/components/notes-customers-form/notes-customers-form.component';

import { HttpParams } from '@angular/common/http';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-items-edit-page',
  imports: [ItemsFormComponent, FormNotesCustomersComponent],
  templateUrl: './items-edit-page.component.html',
  styleUrl: './items-edit-page.component.scss'
})
export class ItemsEditPageComponent {
  itemId!: number
  item?: any;
  itemNotes:any;
  
  constructor(
    private route: ActivatedRoute,
    protected itemsService: ItemsService,
    private routes: RouteService
  ) {
  }

  ngOnInit(): void {
    this.itemId = Number(this.route.snapshot.paramMap.get('itemId'));
    if (this.itemId) {
      this.loadData(this.itemId);
    }
  }

  loadData(itemId: any) {
    const params = new HttpParams().set('size', '9999');
    this.itemsService.detail(itemId).subscribe((response: any) => {
      this.item = response.data?.item;
    });
    this.itemsService.listNotes(this.itemId, { params }).subscribe(response => {
        if (response.status.code === 200) {
          this.itemNotes = response?.data?.sectionNotes;
        }
      });

  }
  onItemFormSavedData(savedDataInfo: SavedDataInfo) {    
    if (savedDataInfo.success) {
     setTimeout(() => {
       this.routes.itemsUpdate(savedDataInfo.response?.data?.item?.itemId);
     }, 1500);
    }
  }
}
